<template>
  <el-badge v-if="theme.showNotice" type="danger" :value="badge">
    <el-popover ref="popover" placement="bottom" trigger="click" :width="300" @show="fetchData">
      <template #reference>
        <vab-icon icon="notification-line" />
      </template>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="translateTitle('通知')" name="notice">
          <div class="notice-list">
            <el-scrollbar>
              <ul>
                <li
                  v-for="(item, index) in notices"
                  :key="index"
                  style="cursor: pointer;"
                  @click="handleNotice(item)"
                >
                  <!-- <span>{{ formatTypehood(item.typehood) }}</span> -->
                  <span>{{ item.basic && item.basic.text }}</span>
                </li>
              </ul>
            </el-scrollbar>
          </div>
        </el-tab-pane>
        <!--
        <el-tab-pane :label="translateTitle('邮件')" name="email">
          <div class="notice-list">
            <el-scrollbar>
              <ul>
                <li v-for="(item, index) in notices" :key="index">
                  <el-avatar :size="45" :src="item.image" />
                  <span>{{ item.email }}</span>
                </li>
              </ul>
            </el-scrollbar>
          </div>
        </el-tab-pane>
        -->
      </el-tabs>
      <div class="notice-clear" @click="handleClearNotice">
        <el-button type="text">
          <vab-icon icon="close-circle-line" />
          <span>{{ translateTitle('清空消息') }}</span>
        </el-button>
      </div>
    </el-popover>
  </el-badge>
</template>

<script>
  import { computed, watch, nextTick, ref, getCurrentInstance, onMounted } from 'vue'
  import { useStore } from 'vuex'
  import { useRouter, useRoute } from 'vue-router'
  import { translateTitle } from '@/utils/i18n'
  import { getNoticeList, getUnReadCount, readRecord } from '@/api/notice'
  import { createNotification } from '@/utils/notification'
  import storejs from 'store'

  export default {
    name: 'VabNotice',
    setup() {
      const store = useStore()
      const router = useRouter()
      const route = useRoute()
      const { proxy } = getCurrentInstance()

      const popover = ref(null)
      let timer = ref(null)
      const notices = ref([])
      const badge = ref(null)
      const activeName = ref('notice')
      const theme = computed(() => store.getters['settings/theme'])

      const fetchData = async () => {
        const data = await getNoticeList({ page: 1, size: badge.value || 10, step: 1 })
        const { list, total } = data
        notices.value = list
      }

      nextTick(() => {
        // if (theme.value.showNotice) fetchData()
      })

      const handleClick = () => {
        // fetchData()
      }

      const handleNotice = async (item) => {
        // console.log('item ------', item )
        const result = await readRecord({ recordIdList: [item.recordId] })
        if (!result) return
        badge.value = badge.value - 1 <= 0 ? null : badge.value - 1
        let url = ''
        if (item.typehood === 3) {
          url = '/customer/chat'
        }
        if (!url) return
        popover.value.hide()
        router.push(url)
      }

      const handleClearNotice = async () => {
        const recordIdList = notices.value.map(i => i.recordId)
        if (recordIdList.length===0) return
        const result = await readRecord({ recordIdList })
        if (!!result) {
          badge.value = null
          notices.value = []
          proxy.$baseMessage(
            '清空消息成功',
            'success',
            false,
            'vab-hey-message-success'
          )
        }
      }

      const formatTypehood = (typehood) => {
        const typehoods = ['客人入住', '维护通知', '客服消息']
        return typehoods[typehood - 1]
      }

      onMounted(() => {
        timer = setInterval(async () => {
          const count = await getUnReadCount()
          if (count !== 0 && count !== badge.value) {
            // const data = await getNoticeList({ page: 1, size: 1, step: 1 })
            // const { list, total } = data
            // const msg = list && list[0]
            // let url = ''
            // const base = 'https://id.qixiaoyun.com/#'
            // if (msg && msg.typehood === 3) {
            //   url = `${base}/customer/chat`
            // }
            // if (!url) {
            //   badge.value = count === 0 ? null : count
            //   return
            // }
            // store.dispatch('notice/updateNoticeCount', count)
            // createNotification(msg && msg.basic && msg.basic.text, url)
            if (storejs.get('isOpenAudio')) {
              const audio = new Audio('https://qbox.yeahotel.com/Fje-CbyqwOA2hArSESbHXjelUfTY');
              audio.play();
            }
          }
          store.dispatch('notice/updateNoticeCount', count)
          badge.value = count === 0 ? null : count
        }, 2000)
      })

      watch(
        () => route.path,
        () => {
          if (route.name === 'Login') {
            clearInterval(timer)
            timer = null
          }
        }
      )

      return {
        badge,
        theme,
        notices,
        popover,
        fetchData,
        activeName,
        handleClick,
        handleNotice,
        translateTitle,
        handleClearNotice,
        formatTypehood,
      }
    },
  }
</script>

<style lang="scss" scoped>
  :deep() {
    .el-tabs__active-bar {
      min-width: 28px;
    }
  }

  .notice-list {
    height: 29vh;

    ul {
      padding: 0 15px 0 0;
      margin: 0;

      li {
        display: flex;
        align-items: center;
        padding: 10px 0 10px 0;

        :deep() {
          .el-avatar {
            flex-shrink: 0;
            width: 50px;
            height: 50px;
            border-radius: 50%;
          }
        }

        span {
          margin-left: 10px;
        }
      }
    }
  }

  .notice-clear {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0 0 0;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    border-top: 1px solid #e8eaec;

    i {
      margin-right: 3px;
    }
  }
</style>
